import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Switch, Tooltip } from '@mui/material';
import './PpaSchemeInfoCell.css';

const PpaSchemeInfoExpandContext = createContext(null);

export const PpaSchemeInfoExpandProvider = ({ children }) => {
    const [expandSignal, setExpandSignal] = useState({
        expanded: false,
        version: 0,
    });

    const expandAll = useCallback(() => {
        setExpandSignal((prev) => ({
            expanded: true,
            version: prev.version + 1,
        }));
    }, []);

    const collapseAll = useCallback(() => {
        setExpandSignal((prev) => ({
            expanded: false,
            version: prev.version + 1,
        }));
    }, []);

    const setExpandedAll = useCallback((expanded) => {
        setExpandSignal((prev) => ({
            expanded: Boolean(expanded),
            version: prev.version + 1,
        }));
    }, []);

    const value = useMemo(
        () => ({
            expandSignal,
            expandAll,
            collapseAll,
            setExpandedAll,
        }),
        [expandSignal, expandAll, collapseAll, setExpandedAll]
    );

    return (
        <PpaSchemeInfoExpandContext.Provider value={value}>
            {children}
        </PpaSchemeInfoExpandContext.Provider>
    );
};

export const usePpaSchemeInfoExpand = () =>
    useContext(PpaSchemeInfoExpandContext);

/** Compact expand-all toggle for Scheme Info column header. */
export const PpaSchemeInfoExpandControls = () => {
    const ctx = usePpaSchemeInfoExpand();
    if (!ctx) return null;

    const checked = Boolean(ctx.expandSignal?.expanded);

    return (
        <Tooltip
            title={checked ? 'Collapse all' : 'Expand all'}
            arrow
            placement="top"
        >
            <span className="ppa-scheme-info__bulk">
                <Switch
                    size="small"
                    checked={checked}
                    onChange={(e) => ctx.setExpandedAll(e.target.checked)}
                    inputProps={{ 'aria-label': 'Expand all activity details' }}
                    color="primary"
                />
            </span>
        </Tooltip>
    );
};

/** Column header: title + expand/collapse toggle. */
export const PpaSchemeInfoColumnHeader = ({ title = 'Scheme Info' }) => (
    <div className="ppa-scheme-info__col-header">
        <span>{title}</span>
        <PpaSchemeInfoExpandControls />
    </div>
);

export default PpaSchemeInfoExpandProvider;
